<!--
 * @FileDescription: 新增/编辑替换SKU规则对话框
 * @Author: 陈文景
 * @Date: 2023-03-22 13:53:38
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog :title="title" :visible.sync="visible" width="620px" :before-close="close">
    <el-form ref="form" :model="form" :rules="rules" size="medium" :label-width="`${labelWidth}px`">
      <el-form-item label="用户分组" prop="platformName">
        <el-radio :disabled="title==='编辑规则'" v-model="form.userGroup" :label="-1">默认</el-radio>
        <el-radio :disabled="title==='编辑规则'" v-model="form.userGroup" :label="100">独立站</el-radio>
      </el-form-item>
      <el-form-item v-if="form.userGroup !== 100" label="kaka账号" prop="userId">
        <el-select v-model="form.userId" size="medium" filterable remote placeholder="邮箱/手机号" :remote-method="userRemoteMethod" :loading="getUserLoading" clearable>
          <el-option v-for="item in userOptions" :key="item.userId" :label="`${item.email||''}${(item.email&&item.phone?' / ':'')}${item.phone||''}`" :value="item.userId" :title="`${item.email||''}${item.phone?' / '+item.phone:''}`" />
        </el-select>
      </el-form-item>

      <el-form-item label="适用平台" prop="platformName">
        <el-select v-model="form.platformName" size="medium" multiple placeholder="请选择">
          <el-option v-for="item in platformOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="平台SKU" prop="beforeSku">
        <el-input v-model="form.beforeSku" placeholder="请输入" :maxlength="50" />
      </el-form-item>

      <el-form-item v-if="form.userGroup === 100" label="公司SKU" prop="afterSku" class="afterSku">
        <el-input v-model="afterSku" placeholder="请输入" @blur="blurAfterreplacementSku" />
      </el-form-item>
      <el-form-item v-else label="公司SKU" prop="afterSku" class="afterSku">
        <div class="sku-list">
          <div v-for="(item, i) in afterSkuList" :key="i" class="f-b-c" style="margin-bottom:4px">
            <el-input v-model="item.afterSku" placeholder="请输入" />
            <el-input-number v-model="item.skuNum" placeholder="输入数量" controls-position="right" :step="1" :min="1" :max="99999" step-strictly style="width:130px;margin-left:20px;flex-shrink: 0;"></el-input-number>
            <i v-if="i === 0" class="el-icon-circle-plus-outline" style="font-size:28px;margin-left:20px" @click="handleSKU('add')"></i>
            <i v-else class="el-icon-circle-close" style="font-size:28px;margin-left:20px" @click="handleSKU('delete', i)"></i>
          </div>
        </div>
      </el-form-item>

      <!-- <el-form-item label="有效期">
        <el-date-picker v-model="dataTime" size="medium" type="datetimerange" :clearable="false" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="onChangeDatePicker" />
      </el-form-item> -->

      <el-form-item label="状态" prop="openStatus">
        <el-switch v-model="form.openStatus" />
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api';
import _ from 'lodash';

let form = {
  id: undefined,
  userGroup: -1,
  userId: undefined,
  platformName: undefined, // 适用平台
  beforeSku: undefined, // 替换前SKU
  // afterSku: undefined, // 替换后SKU
  // effectiveStart: undefined, // 开始时间
  // effectiveEnd: undefined, // 结束时间
  openStatus: true // 状态
}

export default {
  data() {
    let validSKU = (rule, value, callback) => {
      if (this.form.userGroup !== 100) {
        let valid = true
        this.afterSkuList.forEach(item => {
          if (!item.afterSku || !item.skuNum) {
            valid = false
          }
        })
        if (valid) callback()
        else callback(new Error('请输入完整公司SKU信息'))
      } else {
        if (this.afterSku) callback()
        else callback(new Error('请输入公司SKU'))
      }
    }

    return {
      title: '新增规则',

      visible: false,

      labelWidth: 100,

      // 适用平台下拉选项
      platformOptions: [
        { label: '全平台', value: 'Entire' },
        { label: 'Shopify', value: 'Shopify' },
        { label: 'Shoplazza', value: 'Shoplazza' },
        { label: 'Shopline', value: 'Shopline' },
        { label: 'Woocommerce', value: 'Woocommerce' },
        { label: 'TikTok', value: 'TikTok' },
      ],

      form: _.cloneDeep(form), // 表单对象
      dataTime: [], // 日期时间选择器双向绑定的值（发起请求前需要先删除该字段）

      // 规则对象
      rules: {
        userGroup: [{ required: true, message: '请选择用户分组', trigger: 'change' }],
        userId: [{ required: true, message: '请选择kaka账号', trigger: 'change' }],
        platformName: [{ required: true, message: '请选择适用平台', trigger: 'change' }],
        beforeSku: [{ required: true, message: '请输入平台SKU', trigger: ['change', 'blur'] }],
        afterSku: [{ validator: validSKU, trigger: ['change', 'blur'] }],
        // effectiveStart: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
        openStatus: [{ required: true, message: '请选择是否启用', trigger: 'change' }]
      },

      getUserLoading: false,
      userOptions: [],
      afterSku: undefined,
      afterSkuList: []
    }
  },
  mounted() {
  },
  methods: {
    /**
     * 替换后SKU输入框失去焦点后触发的事件
     */
    blurAfterreplacementSku() {
      // this.form.afterSku --> 输入框中的值
    },

    /**
     * 时间日期选择器选中时的事件回调
     *
     * @param {Array} date 当前选中的时间戳数组
     */
    onChangeDatePicker(date) {
      if (date && date.length) {
        this.form.effectiveStart = date[0]
        this.form.effectiveEnd = date[1]
      } else {
        this.form.effectiveStart = undefined
        this.form.effectiveEnd = undefined
      }
    },

    /**
     * 显示对话框
     *
     * @param {Object} payload 当前行数据对象
     */
    show(payload) {
      if (payload) {
        // 编辑
        this.title = '编辑规则'
        Object.keys(payload).forEach((field) => {
          if (Object.keys(this.form).includes(field)) {
            this.form[field] = payload[field]
          }
        })
        this.$set(this.form, 'platformName', payload.platformName ? payload.platformName.split(',') : undefined)
        this.dataTime = [payload.effectiveStart, payload.effectiveEnd]
        this.afterSkuList = payload.skuReplaceDetails.map(t => ({
          afterSku: t.afterSku,
          skuNum: t.skuNum
        }))
        this.afterSku = payload.skuReplaceDetails[0].afterSku
        this.getUserOptions('', payload.userId?[payload.userId]:undefined)
      } else {
        // 新增
        this.title = '新增规则'
        this.afterSkuList = [{
          afterSku: undefined,
          skuNum: 1
        }]
        this.afterSku = undefined
        this.getUserOptions()
      }
      this.visible = true
    },

    /**
     * 保存
     */
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 校验成功
          let parameter = _.cloneDeep(this.form)
          if (parameter.platformName.includes('Entire') || parameter.platformName.filter(t => t !== 'Entire').length === 5) {
            parameter.platformName = 'Entire'
          } else parameter.platformName = parameter.platformName.join()
          if (parameter.userGroup === -1) parameter.skuReplaceDetails = this.afterSkuList
          else {
            let skuReplaceDetails = [{
              afterSku: this.afterSku,
              skuNum: 1
            }]
            parameter.skuReplaceDetails = skuReplaceDetails
          }
          API.skuReplace(parameter).then(res => {
            if (res.code !== 10000) return this.$message.error(res.message)
            this.close()
            this.$emit('success')
          })
        }
      })
    },

    /**
     * 关闭
     */
    close() {
      this.visible = false
      this.clear()
    },

    /**
     * 负责清除数据的方法
     */
    clear() {
      this.form = { ...form }
      this.$refs.form.resetFields()
    },

    async userRemoteMethod(query, userIds) {
      const params = {
        email: query ? query.trim() : '', // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        userIds: userIds || []
      }
      this.getUserLoading = true
      let result = await API.getUserOptions(params)
      this.userOptions = result.data.list
      this.getUserLoading = false
    },
    getUserOptions(query, userIds) {
      this.userRemoteMethod(query, userIds)
    },

    handleSKU(type, i) {
      if (type === 'add') this.afterSkuList.splice(0, 0, { afterSku: undefined, skuNum: 1 })
      else this.afterSkuList.splice(i, 1)
    },
    deleteSKU() {}
  }
}
</script>

<style lang="scss" scoped>
.el-select,
.el-date-editor {
  width: 100%;
}
.afterSku {
  /deep/ .el-form-item__label::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}
</style>
